import sweetalert from 'sweetalert2';

// ベースとなるスタイルを調整
const base = sweetalert.mixin({
  confirmButtonColor: 'var(--color-primary)',
  cancelButtonColor: '#999999',
  denyButtonColor: '#cc3333',
  confirmButtonText: 'OK',
  cancelButtonText: 'キャンセル',
  customClass: {
    popup: 'custom-swal-popup',
    actions: 'custom-swal-actions',
    confirmButton: 'custom-swal-confirm-button',
    cancelButton: 'custom-swal-cancel-button',
  },
  didOpen: () => {
    // data-testidを追加（テスト用）
    const confirmButton = document.querySelector('.custom-swal-confirm-button');
    const cancelButton = document.querySelector('.custom-swal-cancel-button');
    if (confirmButton) {
      confirmButton.setAttribute('data-testid', 'swal-confirm-button');
    }
    if (cancelButton) {
      cancelButton.setAttribute('data-testid', 'swal-cancel-button');
    }
  },
});

/**
 * 複数エラーメッセージダイアログ
 * @param options - エラーメッセージ配列を含むオプション
 * @returns Promise<SweetAlertResult>
 */
const messages = (options: { messages: Array<string> }) => {
  return base.fire({
    title: ' ',
    confirmButtonText: 'OK',
    html: options.messages.join('<br>'),
  });
};

/**
 * 確認
 * @returns
 */
const confirm = (options: {
  title?: string;
  text?: string;
  confirmButtonText?: string;
}) => {
  return base.fire({
    title: options?.title || '確認',
    html: options?.text || '操作を続行します。よろしいですか？',
    confirmButtonText: options?.confirmButtonText || 'OK',
    showCancelButton: true,
  });
};

/**
 * アラート
 * @returns
 */
const alert = (options: { text: string }) => {
  return base.fire({
    title: ' ',
    confirmButtonText: '閉じる',
    text: options.text,
  });
};

/**
 * 入力エラー
 * @returns
 */
const invalid = (text?: string) => {
  return base.fire({
    title: ' ',
    confirmButtonText: 'OK',
    text: text ? text : '入力内容を確認してください。',
  });
};

export const swal = {
  confirm,
  alert,
  messages,
  invalid,
};
